import { Box, CircularProgress, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { useDownloadUsers } from "./DownloadUsersContext";
import { DataGrid } from "@mui/x-data-grid";

const DownloadUserList = () => {
    const { downloadAllUserAcc, setSelectedDownloadUserAcc } = useDownloadUsers();

    const viewEditLinkIcon = (item) => {
        return(
            <Link className="hyper-links" onClick={(e) => setSelectedDownloadUserAcc(item)}>
                {item.id}
            </Link>
        )
        
    }
    const dispRoles = (userAcc) => {
        return(
            userAcc.roles.map((eachrole, idx) => {
                return eachrole + "\n"
            })
        )
    }

    const convertDateISOToUTC = (isoDate) => {
        if( isoDate !==null && isoDate !=="") {
            const date = new Date(isoDate);
            const utcFormatted = `${date.getUTCFullYear()}-${String(date.getUTCMonth()+1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')} ${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}:${String(date.getUTCSeconds()).padStart(2, '0')}`;
            return utcFormatted
        } 
        else return ""; 
    }

    const dataGridColumns = [
        { field: 'id', headerName: 'ID', filterable: true, sortable: true, renderCell:(params) => viewEditLinkIcon(params.row) },
        { field: 'login', headerName: 'Login', filterable: true, sortable: true },
        { field: 'name', headerName: 'Name', filterable: true, sortable: true, width:200 },
        { field: 'organization', headerName: 'Organization', filterable: true, sortable: true, width:300 },
        { field: 'email', headerName: 'Email', filterable: true, sortable: true, width:350 },
        { field: 'roles', headerName: 'Role', filterable: true, sortable: true, width: 140, renderCell:(params) =>  dispRoles(params.row) },
        { field: 'agreementSent', headerName: 'Agreement Sent', filterable: true, sortable: true, width:150, renderCell:(params) => convertDateISOToUTC(params.row.agreementSent) },
        { field: 'agreementReceived', headerName: 'Agreement Received', filterable: true, sortable: true, width:150, renderCell:(params) => convertDateISOToUTC(params.row.agreementReceived) },
        { field: 'approved', headerName: 'Approved', filterable: true, sortable: true, width:150, renderCell:(params) => convertDateISOToUTC(params.row.approved) },
        { field: 'updated', headerName: 'Updated', filterable: true, sortable: true, width:150, renderCell:(params) => convertDateISOToUTC(params.row.updated) }
    ]

    if( downloadAllUserAcc !==null && downloadAllUserAcc.length > 0){
        return ( 
            <>
            <Typography variant="h5" sx={{ mb: 2, textAlign: "center", mt: 2 }}> Manage Download User Accounts </Typography>
            <DataGrid rows={downloadAllUserAcc} columns={dataGridColumns} disableSelectionOnClick sx={{'& .MuiDataGrid-columnHeaders':{ fontSize:'1rem',fontWeight:'bold',display:'flex'}}}/>
            </>
        )
} 
else {
    return(
        <Box sx={{ width: "100%", textAlign: "center", mt: 5 }}>
            <CircularProgress />
        </Box>
    )
}
}

export default DownloadUserList;